import { useState, useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import pickBy from 'lodash.pickby';
import isEmpty from 'lodash.isempty';

//* Helpers
import { getPageNumbers } from './functions';

//* Style
import PaginationStyle from './style';

const Pagination = ({ total, pageSize, nextIcon, prevIcon, onCategoryChange, pageNumbersToShow, currentRefinement }) => {
	const router = useRouter();
	const [hasRouter, setHasRouter] = useState(false);

	useEffect(() => {
		setHasRouter(true);
	}, [router]);

	// !Router
	if (!hasRouter) return null;
	const query = pickBy({ ...(router.query || {}) }, (q) => !isEmpty(q));
	const currentPage = Number(query.page || currentRefinement || 1);

	//! Page Size
	pageSize = Number(query.size) || pageSize;
	const isLastPage = currentPage * pageSize >= total;
	const pageNumbers = getPageNumbers({ currentPage, pageSize, total, pageNumbersToShow });

	return (
		<PaginationStyle className={'mobileStyle'}>
			<div className={'pagination__list'}>
				<div
					className={`prev-btn font-helvetica ${currentPage === 1 ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage - 1)}
				>
					{prevIcon}
				</div>
				{pageNumbers.map((pageNumber, index) => {
					return pageNumber === '...' ? (
						<span
							className='dots pXS'
							key={index}
							label='ellipsis'
						>
							&hellip;
						</span>
					) : (
						<div
							key={index}
							onClick={() => onCategoryChange('page', pageNumber)}
							className={`pagination-item font-helvetica pXS ${pageNumber === currentPage ? 'activePage' : ''}`}
						>
							{pageNumber}
						</div>
					);
				})}
				<div
					className={`next-btn font-helvetica ${isLastPage ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage + 1)}
				>
					{nextIcon}
				</div>
			</div>
		</PaginationStyle>
	);
};

export default Pagination;
